//
//
//
//
//
//
//
//

import {formatDimension} from "../../helpers/format_helpers";

export default {
    name: "AspectRatioBox",

    props: {
        ratio: {
            type: [String, Number],
            default: null,
        }
    },

    computed: {
        wrapperStyle() {
            const style = {};

            if (this.ratio) {
                style.paddingTop = formatDimension(100 / this.ratio, '%')
            }

            return style;
        }
    }
}
